import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Accordion, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Avatar } from '@material-ui/core';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import GenericMessage from '../../../../../Components/GenericMessage/GenericMessage';
import PersonalInfoComponent from '../member-info/PersonalInfo';
import ContactInfo from '../member-info/ContactInfo';
import MasterPermissions from 'src/Member/api/MasterPermissions';
import {
  getViewEmployeeDetails,
  getViewContactInformation,
  formatDependentName,
} from '../../../../utils/common';
import UserDefinedLabels from '../../../../utils/UserDefinedLabels';
import { maskedOther, maskedSSN } from '../../../../../common/masking';
import useDate from '../../../../utils/useDate';
import ProductRow from '../product-selection/ProductRow';
import ProductDentalRow from '../product-selection/ProductDentalRow';
import ProductVisionRow from '../product-selection/ProductVisionRow';
import {
  EditIcon,
  AccordionDownArrow,
  AccordionUpArrow,
} from '../EnrollmentIconsSvg';
import { FileUploadIconSVG } from '../../../../../Components/fileupload/img/FileUploadSVG';
import './review-and-confirm.scss';

const ReviewAndConfirm = ({
  nextStep,
  prevStep,
  enrollmentFormData,
  setEnrollmentFormData,
  handleUpdateFromReview,
}) => {
  console.log('ReviewAndConfirm enrollmentFormData', enrollmentFormData);
  let { themeValuesObject } = useSelector((state) =>
    state?.theme?.branding
      ? state?.theme?.branding
      : { themeValuesObject: { 'Secondary-1': '#1D90BA' } },
  );
  if (!themeValuesObject) {
    themeValuesObject = { 'Secondary-1': '#1D90BA' };
  }
  const navigate = useNavigate();
  const { t } = useTranslation();
  const noValue = 'Not Specified';
  const { formatDate } = useDate();
  const [activeId, setActiveId] = useState(0);
  const { CertificateNumberLabel, AlternateID1Label, AlternateID2Label } =
    UserDefinedLabels();
  const { Suppress_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { selectedMember } = useSelector((state) => state.memberModule || {});
  const loggedInMemberType = selectedMember.mType;
  const selectedEnrollmentFlow = enrollmentFormData.selectedEnrollmentFlow;
  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };
  const {
    MemberInformation = {},
    Memberresidentailaddress = {},
    Membermailingaddress = {},
    MemberPhoneEmailInfo = {},
  } = enrollmentFormData?.updatedMemberInformation || {};

  console.log(
    'MemberInformation ::::::>>>>>> :::::::: ',
    MemberInformation,
    Memberresidentailaddress,
    Membermailingaddress,
  );
  /*Dependent screen changes */
  console.log(
    'enrollmentFormData.removedExistingDependent ::::::::::  ',
    enrollmentFormData.removedExistingDependent,
  );
  const removedNewlyAddedDependent =
    enrollmentFormData.removedExistingDependent.filter((object) => {
      return !object?.DependentNewlyAdded;
    });
  console.log(
    'With out newly dependent ::::::::::  ',
    removedNewlyAddedDependent,
  );

  const changesMadeInDependents = [
    ...enrollmentFormData.allNewlyAddedDependent,
    ...enrollmentFormData.updatedDependentDetails,
    ...removedNewlyAddedDependent,
  ];

  /*Contact details */
  //const PhoneEmailInfo = getViewContactInformation(MemberInformation, false);
  //const employeeInfo = getViewEmployeeDetails(MemberInformation, false);
  /*Address details */
  const residentialAddress =
    enrollmentFormData && enrollmentFormData.updateMemberAddress !== null
      ? enrollmentFormData.updateMemberAddress.maintenanceAddressValues
      : Memberresidentailaddress;
  const mailingAddress =
    enrollmentFormData && enrollmentFormData.updateMemberAddress !== null
      ? enrollmentFormData.updateMemberAddress.mailingAddressValues
      : Membermailingaddress;
  const showUserUpdates =
    enrollmentFormData.isMemberAddressUpdated ||
    (changesMadeInDependents && changesMadeInDependents.length > 0) ||
    enrollmentFormData.products.selectedMedicalProduct ||
    enrollmentFormData.products.selectedDentalProduct ||
    enrollmentFormData.products.selectedVisionProduct ||
    (enrollmentFormData.uploadedDocuments &&
      enrollmentFormData.uploadedDocuments.length > 0);

  const getTotalAmount = () => {
    let total = 0;
    if (enrollmentFormData.products.selectedMedicalProduct) {
      total += parseFloat(
        enrollmentFormData.products.selectedMedicalProduct.monthlyPremium.replace(
          '$',
          '',
        ),
      );
    }
    if (enrollmentFormData.products.selectedDentalProduct) {
      total += parseFloat(
        enrollmentFormData.products.selectedDentalProduct.monthlyPremium.replace(
          '$',
          '',
        ),
      );
    }
    if (enrollmentFormData.products.selectedVisionProduct) {
      total += parseFloat(
        enrollmentFormData.products.selectedVisionProduct.monthlyPremium.replace(
          '$',
          '',
        ),
      );
    }
    return parseFloat(total).toFixed(2);
  };

  const getAddressLine = (address) => {
    console.log('Review and confirm getAddressLine >>>>>>>>>>> ', address);
    return `${address?.Address1 ? address?.Address1 : ''} ${
      address?.Address2 ? address?.Address2 : ''
    } ${address?.Address3 ? address?.Address3 : ''} ${
      address?.County ? address?.County : ''
    } ${address?.City ? address?.City + ',' : ''} ${
      address?.State ? address?.State : ''
    }`;
  };
  const getAddressLineZip = (address) => {
    return `${address?.PostalCode ? address?.PostalCode : ''} ${
      address?.Country ? address?.Country : ''
    } `;
  };

  const submitEnrollmentData = () => {
    navigate('/admin/enrollment-success');
  };
  return (
    <div className="member-info-container">
      <div className="member-info-header">
        <div>Review and Confirm</div>
      </div>
      {showUserUpdates ? (
        <div className="review-page-content-container">
          {enrollmentFormData.isMemberAddressUpdated && (
            <div className="review-page-section-container">
              <div className="review-page-title-content">
                <div className="review-page-title">Employee Profile</div>
                <div>
                  <GenericButton
                    variant="secondary"
                    className="review-page-update-btn"
                    onClick={() => {
                      handleUpdateFromReview('Member Profile');
                    }}
                  >
                    <span>
                      <EditIcon
                        fillColor={
                          themeValuesObject['Secondary-1'] || '#1d90ba'
                        }
                      />
                    </span>
                    <span className="button-text">UPDATE</span>
                  </GenericButton>
                </div>
              </div>
              <div className="my-profile-member-container">
                <div className="bg-white all-profile-component-wrapper">
                  <PersonalInfoComponent
                    employeeInfo={MemberInformation}
                    loggedInMemberType={loggedInMemberType}
                    isReviewPage={true}
                  />
                  <ContactInfo
                    residentialAddress={residentialAddress}
                    mailingAddress={mailingAddress}
                    PhoneEmailInfo={MemberPhoneEmailInfo}
                    showUpdateBtn={false}
                  />
                </div>
              </div>
            </div>
          )}
          {changesMadeInDependents && changesMadeInDependents.length > 0 && (
            <div className="review-page-section-container">
              <div className="review-page-title-content">
                <div className="review-page-title">Dependents Information</div>
                <div>
                  <GenericButton
                    variant="secondary"
                    className="review-page-update-btn"
                    onClick={() => {
                      handleUpdateFromReview('Dependent Information');
                    }}
                  >
                    <span>
                      <EditIcon
                        fillColor={
                          themeValuesObject['Secondary-1'] || '#1d90ba'
                        }
                      />
                    </span>
                    <span className="button-text">UPDATE</span>
                  </GenericButton>
                </div>
              </div>
              <Accordion>
                {/*<Card className="mt-3"> */}
                <div className="personal-info-section">
                  {changesMadeInDependents &&
                    changesMadeInDependents.map((dep, index) => (
                      <div key={index} className="mb-1 hr-sep">
                        <Accordion.Toggle
                          as={Card.Header}
                          onClick={() => toggleActive(index)}
                          className="bg-white panel-toggle border-0 py-3"
                          eventKey={dep.DepSequenceNumber}
                          key={index}
                        >
                          <div className="d-flex panel-card-header align-items-center">
                            <div className="pr-3">
                              <span className="accordion-arrow">
                                {activeId === dep.DepSequenceNumber ? (
                                  <AccordionUpArrow className="acc-arrow" />
                                ) : (
                                  <AccordionDownArrow className="acc-arrow" />
                                )}
                              </span>
                            </div>
                            {/*<div className="top-header-container-dependent border-0 w-100 p-0"> */}
                            <div
                              className={`${
                                selectedEnrollmentFlow === 'AddDependent' ||
                                selectedEnrollmentFlow === 'DeleteDependent' ||
                                selectedEnrollmentFlow === 'AddressChange' ||
                                dep.DependentNewlyAdded
                                  ? 'top-header-container-dependent'
                                  : 'top-header-container'
                              } border-0 w-100 p-0`}
                            >
                              <div className="avarat-wrapper">
                                <Avatar className="my-profile-avatar">
                                  {dep.DepFirstName &&
                                    dep.DepFirstName.charAt(0).toUpperCase()}
                                  {dep.DepLastName &&
                                    dep.DepLastName.charAt(0).toUpperCase()}
                                </Avatar>
                              </div>
                              <div className="title-age-container">
                                <div className="my-profile-title">{`${formatDependentName(
                                  dep,
                                )}`}</div>
                                <div className="my-profile-age">
                                  {dep.RelationshipToEmployee || ''}
                                </div>
                                {selectedEnrollmentFlow === 'AddDependent' &&
                                  !dep.DependentNewlyAdded && (
                                    <div className="my-profile-status display-for-mobile">
                                      <div>Status</div>
                                      <div className="font-weight-bold">
                                        {dep.Status || noValue}
                                      </div>
                                    </div>
                                  )}
                              </div>
                              {selectedEnrollmentFlow === 'AddDependent' ||
                              selectedEnrollmentFlow === 'DeleteDependent' ||
                              selectedEnrollmentFlow === 'AddressChange' ? (
                                <div className="enrollment-dependent-btn-container">
                                  {/*{dep.DependentNewlyAdded ? ( */}
                                  <div className="newly-added-btn-container">
                                    {dep.DependentNewlyAdded ? (
                                      <div className="newly-added-label">
                                        Newly Added
                                      </div>
                                    ) : dep.isDependentUpdated ? (
                                      <div className="newly-added-label">
                                        Updated
                                      </div>
                                    ) : (
                                      <div className="newly-added-label removed-label">
                                        Removed
                                      </div>
                                    )}
                                  </div>
                                  {/*} */}
                                </div>
                              ) : dep.DependentNewlyAdded ? (
                                <div className="enrollment-dependent-btn-container">
                                  <div className="newly-added-btn-container">
                                    <div className="newly-added-label newly-added-label-no-margin">
                                      Newly Added
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="my-profile-status">
                                  <div>Status</div>
                                  <div className="font-weight-bold">
                                    {dep.Status || noValue}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={dep.DepSequenceNumber}>
                          <Card.Body className="bg-white py-2">
                            <>
                              <div className="pt-2 dependent-details-container">
                                <div className="first-column">
                                  {Suppress_Setting?.memberId !== 'hide' && (
                                    <div>
                                      <label>{CertificateNumberLabel}</label>
                                      <span className="plain-text ">
                                        {maskedOther(
                                          Suppress_Setting?.memberId
                                            ? Suppress_Setting?.memberId
                                            : false,
                                          dep.DependentsInformation
                                            .CertificateNumber,
                                        ) || noValue}
                                      </span>
                                    </div>
                                  )}
                                  <div>
                                    <label>
                                      {t('member.pages.my_profile.labels.dob')}
                                    </label>
                                    <span className="plain-text ">
                                      {!dep.DependentsInformation.BirthDate
                                        ? noValue
                                        : formatDate(
                                            dep.DependentsInformation.BirthDate,
                                          )}
                                    </span>
                                  </div>
                                  <div>
                                    <label>
                                      {t(
                                        'member.pages.my_profile.labels.gender',
                                      )}
                                    </label>
                                    <span className="plain-text ">
                                      {dep.DependentsInformation.Gender ||
                                        noValue}
                                    </span>
                                  </div>

                                  <div>
                                    <label>
                                      {t('member.pages.my_profile.labels.race')}
                                    </label>
                                    <span className="plain-text ">
                                      {dep.DependentsInformation.Race ||
                                        noValue}
                                    </span>
                                  </div>
                                </div>
                                <div className="second-column">
                                  <div>
                                    <label>
                                      {t('member.pages.my_profile.labels.age')}
                                    </label>
                                    <span className="plain-text ">
                                      {dep.DependentsInformation.Age +
                                        ' years' || noValue}
                                    </span>
                                  </div>

                                  {Suppress_Setting?.SSN !== 'hide' &&
                                    dep.DependentsInformation
                                      .SocialSecurityNumber && (
                                      <div>
                                        <label>
                                          {t(
                                            'member.pages.my_profile.labels.ssn',
                                          )}
                                        </label>
                                        <span className="plain-text ">
                                          {maskedSSN(
                                            Suppress_Setting?.SSN
                                              ? Suppress_Setting?.SSN
                                              : false,
                                            dep.DependentsInformation
                                              .SocialSecurityNumber,
                                          )}
                                        </span>
                                      </div>
                                    )}

                                  {Suppress_Setting?.altId1 !== 'hide' && (
                                    <div>
                                      <label>{AlternateID1Label}</label>
                                      <span className="plain-text ">
                                        {maskedOther(
                                          Suppress_Setting?.altId1
                                            ? Suppress_Setting?.altId1
                                            : false,
                                          dep.DependentsInformation
                                            .AlternateID1,
                                        ) || noValue}
                                      </span>
                                    </div>
                                  )}

                                  {Suppress_Setting?.altId2 !== 'hide' && (
                                    <div>
                                      <label>{AlternateID2Label}</label>
                                      <span className="plain-text ">
                                        {maskedOther(
                                          Suppress_Setting?.altId2
                                            ? Suppress_Setting?.altId2
                                            : false,
                                          dep.DependentsInformation
                                            .AlternateID2,
                                        ) || noValue}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="pt-2">
                                <div className="contact-info-section">
                                  <div className="top-header-container">
                                    <div className="title">
                                      {t(
                                        'member.pages.my_profile.labels.contact_information',
                                      )}
                                    </div>
                                    {/*{!dep.DependentNewlyAdded && (
                                          <div>
                                            <GenericButton
                                              variant="secondary"
                                              className="btn-update-contact-info"
                                              onClick={() => {
                                                updateDependentsContactInfo(
                                                  depResidenceAddress,
                                                  depMailingAddress,
                                                  item.DependentsInformation,
                                                );
                                              }}
                                            >
                                              <EditIcon
                                                fillColor={
                                                  themeValuesObject[
                                                    'Secondary-1'
                                                  ] || '#1d90ba'
                                                }
                                              />{' '}
                                              UPDATE
                                            </GenericButton>
                                          </div>
                                        )} */}
                                  </div>
                                  <div className="pt-2 dependent-details-container">
                                    <div className="first-column">
                                      <div>
                                        <label>
                                          {t('member.common_labels.email')}
                                        </label>
                                        <span className="plain-text ">
                                          {dep.PhoneEmailInfo?.Email1 ||
                                            noValue}
                                        </span>
                                      </div>
                                      <div>
                                        <label>
                                          {t(
                                            'member.common_labels.alternate_email',
                                          )}
                                        </label>
                                        <span className="plain-text ">
                                          {dep.PhoneEmailInfo?.Email2 ||
                                            noValue}
                                        </span>
                                      </div>
                                      <div>
                                        <label>
                                          {t(
                                            'member.pages.my_profile.labels.home_phone',
                                          )}
                                        </label>
                                        <span className="plain-text ">
                                          {dep.PhoneEmailInfo?.HomePhone
                                            ? dep.PhoneEmailInfo?.HomePhone.replace(
                                                /\D/g,
                                                '',
                                              ).substring(0, 10) &&
                                              `+1 (${dep.PhoneEmailInfo?.HomePhone.substring(
                                                0,
                                                3,
                                              )}) ${dep.PhoneEmailInfo?.HomePhone.substring(
                                                3,
                                                6,
                                              )} ${dep.PhoneEmailInfo?.HomePhone.substring(
                                                6,
                                                10,
                                              )}`
                                            : noValue}
                                        </span>
                                      </div>
                                      <div>
                                        <label>
                                          {t(
                                            'member.pages.my_profile.labels.work_phone',
                                          )}
                                        </label>
                                        <span className="plain-text ">
                                          {dep.PhoneEmailInfo?.WorkPhone
                                            ? dep.PhoneEmailInfo?.WorkPhone.replace(
                                                /\D/g,
                                                '',
                                              ).substring(0, 10) &&
                                              `+1 (${dep.PhoneEmailInfo?.WorkPhone.substring(
                                                0,
                                                3,
                                              )}) ${dep.PhoneEmailInfo?.WorkPhone.substring(
                                                3,
                                                6,
                                              )} ${dep.PhoneEmailInfo?.WorkPhone.substring(
                                                6,
                                                10,
                                              )}`
                                            : noValue}
                                        </span>
                                      </div>
                                      <div>
                                        <label>
                                          {t(
                                            'member.pages.my_profile.labels.mobile_phone',
                                          )}
                                        </label>
                                        <span className="plain-text ">
                                          {dep.PhoneEmailInfo?.MobilePhone
                                            ? dep.PhoneEmailInfo?.MobilePhone.replace(
                                                /\D/g,
                                                '',
                                              ).substring(0, 10) &&
                                              `+1 (${dep.PhoneEmailInfo?.MobilePhone.substring(
                                                0,
                                                3,
                                              )}) ${dep.PhoneEmailInfo?.MobilePhone.substring(
                                                3,
                                                6,
                                              )} ${dep.PhoneEmailInfo?.MobilePhone.substring(
                                                6,
                                                10,
                                              )}`
                                            : noValue}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="second-column">
                                      <div>
                                        <label>
                                          {t(
                                            'member.common_labels.residential_address',
                                          )}
                                        </label>
                                        <span className="plain-text ">
                                          {dep.isDependentUpdated
                                            ? getAddressLine(
                                                dep.DependentResidentailAddress,
                                              ).trim()
                                            : dep.DependentResidentailAddress.trim() ||
                                              noValue}
                                          <br />
                                          {dep.isDependentUpdated
                                            ? getAddressLineZip(
                                                dep.DependentResidentailAddressZip,
                                              ).trim() || ''
                                            : dep.DependentResidentailAddressZip.trim() ||
                                              ''}
                                        </span>
                                      </div>
                                      <div>
                                        <label>
                                          {t(
                                            'member.common_labels.mailing_address',
                                          )}
                                        </label>
                                        <span className="plain-text ">
                                          {dep.isDependentUpdated
                                            ? getAddressLine(
                                                dep.DependentMailingAddress,
                                              ).trim()
                                            : dep.DependentMailingAddress.trim() ||
                                              noValue}
                                          <br />
                                          {dep.isDependentUpdated
                                            ? getAddressLineZip(
                                                dep.DependentMailingAddressZip,
                                              ).trim() || ''
                                            : dep.DependentMailingAddressZip.trim() ||
                                              ''}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          </Card.Body>
                        </Accordion.Collapse>
                      </div>
                    ))}
                </div>
                {/*</Card> */}
              </Accordion>
            </div>
          )}
          {(enrollmentFormData.products.selectedMedicalProduct ||
            enrollmentFormData.products.selectedDentalProduct ||
            enrollmentFormData.products.selectedVisionProduct) && (
            <div className="review-page-section-container">
              <div className="review-page-title-content">
                <div className="review-page-title">Products</div>
                <div>
                  <GenericButton
                    variant="secondary"
                    className="review-page-update-btn"
                    onClick={() => {
                      handleUpdateFromReview('Product Selection');
                    }}
                  >
                    <span>
                      <EditIcon
                        fillColor={
                          themeValuesObject['Secondary-1'] || '#1d90ba'
                        }
                      />
                    </span>
                    <span className="button-text">UPDATE</span>
                  </GenericButton>
                </div>
              </div>
              {enrollmentFormData.products.selectedMedicalProduct && (
                <>
                  <div className="sub-title">Medical Coverage</div>
                  <div className="plan-selection-row">
                    <ProductRow
                      data={enrollmentFormData.products.selectedMedicalProduct}
                      selectedCheckedItems={''}
                      setSelectedCheckedItems={() => null}
                      selectedCheckedRowData={''}
                      setSelectedCheckedRowData={() => null}
                      enrollmentFormData={enrollmentFormData}
                      setEnrollmentFormData={setEnrollmentFormData}
                      onSelectedProducts={() => null}
                      onSelectedEnrollMembers={() => null}
                      selectedTab={''}
                      isTabClicked={null}
                      setIsTabClicked={() => null}
                      isNotReviewPage={false}
                    />
                  </div>
                </>
              )}
              {enrollmentFormData.products.selectedDentalProduct && (
                <>
                  <div className="sub-title">Dental Coverage</div>
                  <div className="plan-selection-row">
                    <ProductDentalRow
                      data={enrollmentFormData.products.selectedDentalProduct}
                      selectedCheckedItems={''}
                      setSelectedCheckedItems={() => null}
                      selectedCheckedRowData={''}
                      setSelectedCheckedRowData={() => null}
                      enrollmentFormData={enrollmentFormData}
                      setEnrollmentFormData={setEnrollmentFormData}
                      onSelectedProducts={() => null}
                      onSelectedEnrollMembers={() => null}
                      selectedTab={''}
                      isTabClicked={null}
                      setIsTabClicked={() => null}
                      isNotReviewPage={false}
                    />
                  </div>
                </>
              )}
              {enrollmentFormData.products.selectedVisionProduct && (
                <>
                  <div className="sub-title">Vision Coverage</div>
                  <div className="plan-selection-row">
                    <ProductVisionRow
                      data={enrollmentFormData.products.selectedVisionProduct}
                      selectedCheckedItems={''}
                      setSelectedCheckedItems={() => null}
                      selectedCheckedRowData={''}
                      setSelectedCheckedRowData={() => null}
                      enrollmentFormData={enrollmentFormData}
                      setEnrollmentFormData={setEnrollmentFormData}
                      onSelectedProducts={() => null}
                      onSelectedEnrollMembers={() => null}
                      selectedTab={''}
                      isTabClicked={null}
                      setIsTabClicked={() => null}
                      isNotReviewPage={false}
                    />
                  </div>
                </>
              )}
              {/*<>
                <div className="total-amount-container">
                  <div className="total-amount-sub-container">
                    <div className="plan-price">$ {getTotalAmount()}</div>
                    <div className="plan-premium">Monthly Premium</div>
                    <div className="plan-amount">(+$56.00 Monthly)</div>
                  </div>
                </div>
              </> */}
            </div>
          )}
          {enrollmentFormData.uploadedDocuments &&
            enrollmentFormData.uploadedDocuments.length > 0 && (
              <div className="review-page-section-container">
                <div className="review-page-title-content">
                  <div className="review-page-title">Documents</div>
                  <div>
                    <GenericButton
                      variant="secondary"
                      className="review-page-update-btn"
                      onClick={() => {
                        handleUpdateFromReview('Upload Documents');
                      }}
                    >
                      <span>
                        <EditIcon
                          fillColor={
                            themeValuesObject['Secondary-1'] || '#1d90ba'
                          }
                        />
                      </span>
                      <span className="button-text">UPDATE</span>
                    </GenericButton>
                  </div>
                </div>
                <div className="file-container">
                  {enrollmentFormData.uploadedDocuments &&
                    enrollmentFormData.uploadedDocuments.map((d, index) => (
                      <div key={index} className="file-name">
                        <span>
                          <FileUploadIconSVG />
                        </span>
                        <span className="file-name-text">{d.file.name}</span>
                      </div>
                    ))}
                </div>
              </div>
            )}
        </div>
      ) : (
        <div className="review-page-content-container">
          <GenericMessage
            wrapperClasses="mt-4 mb-4"
            message="It looks like you haven't updated any information yet! Update any required information or preferred product before submitting."
            messageType={'warning'}
            showMessage={true}
            hideCloseButton={true}
          />
        </div>
      )}

      <div className="ml4 mr-4 pb-4">
        <Row>
          <Col className="d-flex justify-content-end">
            <GenericButton
              variant="link"
              onClick={() => {
                prevStep();
              }}
              className="form-btn"
            >
              Back
            </GenericButton>
            <GenericButton
              type="button"
              className="mr-0"
              onClick={() => {
                submitEnrollmentData();
              }}
            >
              Save
            </GenericButton>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ReviewAndConfirm;
